import { render, staticRenderFns } from "./addResponsibleForPdf.vue?vue&type=template&id=5c621f32&scoped=true&"
import script from "./addResponsibleForPdf.vue?vue&type=script&lang=js&"
export * from "./addResponsibleForPdf.vue?vue&type=script&lang=js&"
import style0 from "./addResponsibleForPdf.vue?vue&type=style&index=0&id=5c621f32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c621f32",
  null
  
)

export default component.exports